<template>
  <div class="d-flex align-items-center justify-content-center py-3 " v-if="total>0">
    <div class="small pe-3">共 {{ total }} 条 </div>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item " :class="{ disabled: currentPage === 1 }">
          <a class="page-link point-curser" aria-label="Previous" @click="changePage(currentPage - 1)">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li class="page-item  "  v-for="page in pageRange"
            :key="page"
            :class="{ active: page === currentPage }">
          <a class="page-link point-curser" @click="changePage(page)">{{page}}</a>
        </li>
        <li class="page-item " :class="{ disabled: currentPage === totalPages }">
          <a class="page-link point-curser"  aria-label="Next" @click="changePage(currentPage + 1)">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
    <!-- 分页选择器 -->
    <div class="pagination-controls d-sm-block d-none" >
      <select :value="pageSize" @change="onItemsPerPageChange" class="form-select form-select-sm" id="itemsPerPage">
        <option value="10">10条/页</option>
        <option value="20">20条/页</option>
        <option value="30">30条/页</option>
        <option value="50">40条/页</option>
      </select>
    </div>
    <div class="mx-2 d-flex align-items-center justify-content-center d-sm-block d-none">
      <text class="flex-shrink-0">到第</text>
      <input type="number" @input="pageChange" v-model="inputPage"  min="1" class="pageNumberinput border text-center border-none mx-1" >
       <text class="flex-shrink-0">页</text>
    </div>
<!--    <div class="changeBtn mx-2">-->
<!--      <button class="btn btn-outline-primary btn-sm">确定</button>-->
<!--    </div>-->
  </div>
</template>

<script setup>
import { ref, computed,defineProps,defineEmits,watch } from 'vue';
import {showToast} from "@/utils/toast";
const props = defineProps({
  // 总数
  totalIn: {
    type: Number,
    required: true,
  },
  // 页码
  currentIn: {
    type: Number,
    default:1,
    required: true,
  },
  // 每页条数
  pageSizeIn: {
    type: Number,
    default:10,
    required: true,
  }
})
const emit = defineEmits(["pageChange"])
const total = ref(0)
const pageSize = ref(10)
const currentPage = ref(1)
const inputPage = ref() // 输入的页码

// 检测总数变化
watch(
    () => props.totalIn,
    (a) => {
      if(Number.isInteger(a)){
      total.value = a;
      }
    },{immediate:true}

);
// 监测页码变化
watch(
    () => props.pageSizeIn,
    (a) => {
      if(Number.isInteger(a)){
      pageSize.value = a;
    }
    },{immediate:true}
);
// 监测页码变化
watch(
    () => props.currentIn,
    (a) => {
      if(Number.isInteger(a))
      currentPage.value = a;
    },{immediate:true}
);
// 计算总页数
const totalPages = computed(() => {
  return Math.ceil(total.value / pageSize.value);

});
// 计算页码范围（最多显示 5 个页码）
const pageRange = computed(() => {
  const range = [];
  const maxPagesToShow = 5; // 最多显示 5 页
  const start = Math.max(1, currentPage.value - 2);
  const end = Math.min(totalPages.value, currentPage.value + 2);
  for (let i = start; i <= end; i++) {
    range.push(i);
  }
  // 如果显示的页码少于 5 个，需要调整页码范围
  if (range.length < maxPagesToShow) {
    // 如果当前页较小，向右扩展
    if (currentPage.value <= 3) {
      for (let i = range[range.length - 1] + 1; i <= Math.min(totalPages.value, range[range.length - 1] + (maxPagesToShow - range.length)); i++) {
        range.push(i);
      }
    }
    // 如果当前页较大，向左扩展
    else if (currentPage.value >= totalPages.value - 2) {
      for (let i = range[0] - 1; i >= Math.max(1, range[0] - (maxPagesToShow - range.length)); i--) {
        range.unshift(i);
      }
    }
  }
  return range;
});

// 切换页数
const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
  emit("pageChange",{page:currentPage.value,pageSize:pageSize.value})
};

// 切换页码
const onItemsPerPageChange = (e)=>{
  let data = e.target.value
  currentPage.value = 1
  pageSize.value = data
  emit("pageChange",{page:currentPage.value,pageSize:pageSize.value})

}
// 输入页码改变
const pageChange = (e)=>{
  let data = e.target.value
  if (Number.isInteger(parseFloat(data))) {
    data = data-0
    if(0< data && data <=totalPages.value){
      currentPage.value = parseFloat(data)
      emit("pageChange",{page:currentPage.value,pageSize:pageSize.value})
    }else{
      inputPage.value = "" // 输入的范围不对
      showToast("warning","您输入的页码有误")
    }

  } else {
    inputPage.value = "" // 输入的不对，清空
  }

}
</script>

<style scoped>
.pagination {
  display: flex;
  list-style: none;
  padding-left: 0;
}
.pagination .page-item {
  margin: 0 2px;
  user-select: none;
}
.pagination .page-item.disabled .page-link {
  pointer-events: none !important;
}
.pagination .page-item.active .page-link {
  font-weight: bold;
}
.pageNumberinput{
  background-color: transparent;
  /*border: none;*/
  outline: none;
  -webkit-appearance: none; /* 针对Safari和Chrome*/
  height: 1.8rem;
  line-height: 1.8rem;
  width: 55px;
}

.pageNumberinput:hover,.pageNumberinput:active{
  /*border:none;*/
}
.changeBtn{
  min-width: 60px;
}

</style>
